<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container class="monitoring">
		<v-layout v-if="monitoringData.monitoringStatus === 'STARTED'" class="d-none print-only">
			<div><h1>Wydruk próbny !</h1></div>
		</v-layout>

		<v-layout class="no-print">
			<v-btn @click="openProjectView">
				Podgląd projektu
			</v-btn>
			<v-spacer/>
			<v-btn @click="print" v-if="readOnly">
				Wydrukuj monitoring
			</v-btn>
		</v-layout>

		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Raport z monitoringu</h2>
				<div class="project-monitoring-card monitoring-font-size">
					<div>
						<strong class="mr-3">Nazwa projektu:</strong> {{monitoringData.projectName}}
					</div>
					<div>
						<strong class="mr-3">Numer projektu:</strong> {{monitoringData.projectCode}}
					</div>
					<div>
						<strong class="mr-3">Suma kontrolna:</strong> {{monitoringData.controlSum}}
					</div>
					<div>
						<strong class="mr-3">Nazwa placówki:</strong> {{monitoringData.agencyName}}
					</div>
					<div class="mt-3">
						<strong class="mr-3">Status monitoringu:</strong>
						{{getStatusText(monitoringData.monitoringStatus)}}
					</div>
					<div>
						<strong class="mr-3">Główny kraj:</strong> {{monitoringData.mainCountry}}
					</div>
					<div
						v-if="monitoringData.extraCountries && monitoringData.extraCountries.length > 0">
						<strong class="mr-3">Kraje dodatkowe:</strong> {{monitoringData.extraCountries.join(", ")}}
					</div>
					<div class="mt-3">
						<strong class="mr-3">Opiekun projektu:</strong> {{monitoringData.supervisorName || "Brak"}}
					</div>
					<div>
						<strong class="mr-3">Raport utworzony przez:</strong> {{monitoringData.creatorName}}
					</div>
					<div v-if="monitoringData.finisherName">
						<strong class="mr-3">Raport zakończony przez:</strong> {{monitoringData.finisherName}}
					</div>
					<div v-if="monitoringData.finishDate">
						<strong class="mr-3">Data złożenia raportu:</strong> {{monitoringData.finishDate}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">

		<div class="mt-3 mb-3" v-if="configuration.form.sections">
			<h2 style="margin-left: 20px">{{configuration.form.sections[0].name}} </h2>
			<vue-form-generator
				name="generator"
				ref="vfg"
				:model="monitoringData.model"
				:options="formGenerator.formOptions"
				:schema="formGenerator.currentSchema"
				v-if="viewData.showGenerator">
			</vue-form-generator>
		</div>

		<v-form ref="form">
			<div style="page-break-inside: avoid">
				<v-autocomplete
					class="no-print"
					label="Osoby przeprowadzające monitoring"
					:disabled="configuration.disabled"
					v-model="monitoringData.monitoringUsers"
					:items="possibleMonitoringUsers"
					item-text="fullName"
					item-value="id"
					data-vv-name="monitoringUsers"
					data-vv-as="Placówka"
					aria-label="monitoring user"
					:error-messages="vErrors.collect('monitoringUsers')"
					:rules="validation.userRules"
					multiple
					validate-on-blur
				></v-autocomplete>
				<div class="d-none print-only ml-3 header-card-font-size">
					Osoby przeprowadzające monitoring: <strong
						class="ml-2 header-card-font-size">{{monitoringUserList}}</strong>
				</div>
			</div>

			<div style="page-break-inside: avoid">
				<div class="no-print">
					<v-menu
						:close-on-content-click="false"
						:nudge-right="40"
						full-width
						lazy
						min-width="290px"
						offset-y
						transition="scale-transition"
						v-model="open"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								browser-autocomplete="off"
								:disabled="configuration.disabled"
								label="Data wykonania"
								readonly
								v-model="monitoringData.finishDate"
								data-vv-name="finishDate"
								:rules="[validation.required]"
								:error-messages="vErrors.collect('finishDate')"
								v-on="on"
								aria-label="monitoring finish date"
								validate-on-blur
							></v-text-field>
						</template>

						<v-date-picker
							:first-day-of-week="1"
							v-model="monitoringData.finishDate"
							no-title
							scrollable
							@input="open = false"
							locale="pl-PL"
						></v-date-picker>
					</v-menu>
				</div>
				<div class="d-none print-only ml-3 mt-2 header-card-font-size">
					Data wykonania: <strong
						class="ml-2 header-card-font-size">{{monitoringData.finishDate}}</strong>
				</div>
			</div>
		</v-form>

		<v-layout align-center>
			<h3 class="mt-4 mb-4 ml-4">Załączniki</h3>
			<div v-if="!configuration.disabled">
				<v-btn @click="$refs.file.click()" class="ma-2 ml-4">
					{{"Dodaj załącznik"}}
				</v-btn>
				<input type="file" v-show="false" ref="file" id="fileInput"
					:accept="acceptedFiles"
					v-on:change="addAttachment">
			</div>
		</v-layout>
		<v-layout v-for="(attachment, index) in monitoringData.attachments" :key="index">
			<div>{{index+1}}:&nbsp; <i> {{attachment.fileName}} </i></div>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on" class="ma-0 v-btn-mini no-print"
						@click="downloadAttachment(index, attachment)">
						<v-icon class="margin: 0px" small>cloud_download</v-icon>
					</v-btn>
				</template>
				<span>Pobierz</span>
			</v-tooltip>
			<v-tooltip top v-if="!configuration.disabled">
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on" class="ma-0 v-btn-mini no-print" @click="removeAttachment(index)">
						<v-icon class="margin: 0px" color="lightred" small>delete</v-icon>
					</v-btn>
				</template>
				<span>Usuń</span>
			</v-tooltip>
		</v-layout>

		<v-layout mt-3 class="no-print">
			<v-btn v-if="monitoringData.monitoringStatus !== 'FINISHED' && !readOnly" @click="validateAndShowDialog">
				<v-icon class="mr-2 white--text">send</v-icon>
				Wyślij
			</v-btn>
			<v-btn v-if="!configuration.disabled" @click="saveReport" color="info">
				<v-icon class="mr-2 white--text">save</v-icon>
				Zapisz raport
			</v-btn>
		</v-layout>

		<report-confirmation-dialog :action="sendReport" :dialog-model="viewData.sendReportDialog"
			@close-confirmation="viewData.sendReportDialog = false"
			action-label="Wyślij" content="Przed wysłaniem sprawozdania upewnij się, że jest poprawnie wypełnione.
				Po wysłaniu nie będzie już możliwości edycji!" header="Wysyłka raportu" icon="send"/>

		<v-layout v-if="monitoringData.monitoringStatus === 'STARTED'" class="d-none print-only">
			<div><h1>Wydruk próbny !</h1></div>
		</v-layout>

	</v-container>
</template>

<script>
	import {Api} from "@/api";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import ReportConfirmationDialog from "../report/ReportConfirmationDialog";
	import {Files} from "@/utils/Files";
	import {Numbers} from "@/utils/Numbers";
	import {AgencyMonitoring} from "@/api/generated/AgencyMonitoring";

	export default {
		name: "AgencyProjectMonitoringFormView",
		components: {ReportConfirmationDialog},
		props: {
			readOnly: {type: Boolean, required: false, default: false}
		},
		data() {
			return {
				monitoringData: {
					model: undefined,
					monitoringUsers: [],
					possibleMonitoringUsers: [],
					startDate: null,
					endDate: null,
					finishDate: undefined,
					attachments: [],
				},

				configuration: {
					form: "",
					disabled: false,
				},
				viewData: {
					showGenerator: false,
					sendReportDialog: false,
				},
				validation: {
					userRules: [
						v => v.length > 0 || "Przynajmniej jeden użytkownik powinien być wybrany",
					],
					required: function (value) {
						if (value === null || value === "" || value === undefined) return "To pole jest wymagane.";
						return true;
					},
				},
				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: [],
				},
				open: false,
				projectId: this.$route.params.projectId,
			};
		},

		mixins: [Files, Numbers],

		created() {
			this.loadData();
			this.$store.commit("loadAgencyProjectPanelPermissions", {context: this, projectId: this.$route.params.projectId});
		},

		watch: {
			"monitoringData.model": {
				handler() {
					this.applyGenericForm(this.configuration.form);
				},
				deep: () => !this.readOnly,
			},
		},

		computed: {
			possibleMonitoringUsers() {
				return this.monitoringData.possibleMonitoringUsers.map(user => {
					return {
						id: user.id,
						fullName: user.name + " " + user.surname,
					};
				});
			},

			monitoringUserList () {
				let users = [];
				for (let itemId of this.monitoringData.monitoringUsers) {
					let found = this.possibleMonitoringUsers.find(item => item.id === itemId);
					if (found) users.push(found.fullName);
				}
				return users.join(', ');
			}
		},

		methods: {
			async loadData() {
				await Api.syncGet(this, "/agency-monitoring/configuration?agencyProjectId=".concat(this.$route.params.projectId), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);
				});

				AgencyMonitoring.get(this, this.$route.params.monitoringId, response => {
					for (let field in response) {
						if (response.hasOwnProperty(field)) {
							this.monitoringData[field] = response[field];
						}
					}

					this.monitoringData.monitoringUsers = this.monitoringData.monitoringUsers.map(user => user.id);

					if (!this.editionPossible(response.monitoringStatus)) {
						this.configuration.disabled = true;
					}
					if (response.filledForm === null) {
						this.monitoringData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.monitoringData.model = genericFormUtil.decodeSchema(response.filledForm);
					}

					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;
				});

				if (!this.configuration.disabled) {
					AgencyMonitoring.getPossibleUsers(this, response => {
						this.monitoringData.possibleMonitoringUsers = response.sort((a, b) => {
							let nameA = a.surname.toUpperCase();
							let nameB = b.surname.toUpperCase();
							if (nameA === nameB) {
								nameA = a.name.toUpperCase();
								nameB = b.name.toUpperCase();
								if (nameA > nameB) {
									return 1;
								} else if (nameA < nameB) {
									return -1;
								} else {
									return 0;
								}
							}
							if (nameA > nameB) {
								return 1;
							} else if (nameA < nameB) {
								return -1;
							} else {
								return 0;
							}
						});
					});
				}
			},

			applyGenericForm(form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.monitoringData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async validateAndShowDialog() {
				let validatePromise = await this.$refs.vfg.validate();
				if (validatePromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane formularza");
					return;
				}
				let valid = await this.$refs.form.validate();
				if (!valid) {
					this.$messagesBus.$emit("error", "Uzupełnij dane monitoringu");
				} else {
					this.viewData.sendReportDialog = true;
				}
			},

			saveReport() {
				AgencyMonitoring.put(this, this.$route.params.monitoringId, this.prepareFormData(), successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano raport z monitoringu", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać raportu z monitoringu", errorResponse);
				});
			},

			async sendReport() {
				let validationPromise = await this.$refs.vfg.validate();
				let formValid = await this.$refs.form.validate();
				const valid = validationPromise.length === 0 && formValid;
				if (!valid) {
					this.viewData.sendReportDialog = false;
					return;
				}

				let data = this.prepareFormData();
				AgencyMonitoring.putFinish(this, this.$route.params.monitoringId, data, successResponse => {
					this.$messagesBus.$emit("success", "Raport został wysłany", successResponse);
					this.$router.push("/app/agency-contest/" + this.$route.params.id + "/project-panel/" + this.$route.params.projectId + "/monitoring");
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wysłać raportu", errorResponse);
				});
			},

			async loadAttachments() {
				AgencyMonitoring.get(this, this.$route.params.monitoringId, response => {
					this.monitoringData.attachments = response.attachments;
				});
			},


			prepareFormData() {
				return {
					filledForm: genericFormUtil.encodeSchema(this.monitoringData.model),
					monitoringUserIds: this.monitoringData.monitoringUsers,
					finishDate: this.monitoringData.finishDate,
				};
			},

			async addAttachment() {
				if (this.hasIncorrectFilesExtension(this.$refs.file.files)) {
					Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.file.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('fileInput');
					return;
				}
				Api.postMultipart(this, "/agency-monitoring/attachment?monitoringId=" + this.$route.params.monitoringId, this.$refs.file.files[0], {}, () => {
          Files.methods.clearFileInput('fileInput');
					this.loadAttachments();
				});
			},

			downloadAttachment(index, attachment) {
				this.downloadAgencyMonitoringAttachment(this, this.$route.params.monitoringId, index, attachment.fileName);
			},

			removeAttachment(index) {
				AgencyMonitoring.deleteAttachment(this, parseFloat(this.$route.params.monitoringId), index, this.loadAttachments);
			},

			getStatusText(status) {
				switch (status) {
					case "STARTED":
						return "Rozpoczęty";
					case "REVISION":
						return "Oddany do poprawki";
					case "FINISHED":
						return "Zakończony";
				}
			},

			editionPossible(status) {
				return !this.readOnly && (status !== 'FINISHED' || this.hasAgencyProjectPanelAdminModificationAccess());
			},

			hasAgencyProjectPanelAdminModificationAccess(){
				return this.$store.state.agencyProjectPanelPermissions.hasAgencyProjectPanelAdminModificationAccess;
			},

      openProjectView() {
        this.$router.openInNewTab('/view/agency-contest/' + this.monitoringData.agencyContestId + '/project/' + this.monitoringData.agencyId + '/' + this.projectId);
      },

			async print() {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getAgencyMonitoringPrintUrl(this.projectId, this.$route.params.monitoringId),
					"monitoring.pdf");
			},
		},
	};
</script>

<style scoped>
	.header-card-font-size {
		font-size: 14px;
	}

	@media print {
		.header-card-font-size {
			font-size: 13px;
		}

		.monitoring-font-size * {
			font-size: 13px;
		}
	}

	.v-btn-mini {
		height: auto;
		width: auto;
		padding-left: 10px;
	}
</style>
